export const COPY_SUCCESS = "Password successfully copied to clipboard";
export const COPY_Fail = "Something went wrong, Password didn't saved";
